module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Dedication-rw",
    attrs: {
      "epub:type": "frontmatter dedication",
      "id": "Dedication1"
    }
  }, [_c('div', {
    staticClass: "block-rw dedication-rw",
    attrs: {
      "id": "dedication1"
    }
  }, [_c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p39"
    }
  }, [_c('span', [_vm._v("To my family.")])]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p40"
    }
  }, [_c('span', [_vm._v("You lift me up.")])]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p41"
    }
  }, [_c('span', [_vm._v("You make me proud.")])]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p42"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p43"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "ded-rw",
    attrs: {
      "id": "p44"
    }
  }, [_c('span', [_vm._v("And to Tom, always and forever.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ecd317e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s003-Dedication-01.vue
// module id = 66
// module chunks = 0